module.exports = __webpack_public_path__ + "img/ERIC_MISKA.5dbb3953.png";